import { unwrapNodes } from "@/helpers/graphql";

const SWATCH_COLOURS = {
  black: "#1A1A1A",
  white: "#FFFFFF",
  cream: "#F5F0E6",
  ivory: "#FFFFF0",
  ecru: "#F3EFE5",
  oatmeal: "#D9CFC0",
  beige: "#D8C3A5",
  nude: "#D8B9A6",
  tan: "#C9A27A",
  camel: "#C19A6B",
  brown: "#7A4E2D",
  chocolate: "#4A2C1A",
  caramel: "#A86B3C",
  rust: "#A34A28",
  orange: "#E07030",
  coral: "#E87461",
  peach: "#F2B8A2",
  apricot: "#F2B07A",
  red: "#B42318",
  burgundy: "#6B1F2A",
  wine: "#722F37",
  maroon: "#5C1A24",
  rose: "#D8899B",
  blush: "#E8B4B8",
  pink: "#E8A0A8",
  magenta: "#B83280",
  fuchsia: "#C71585",
  purple: "#6B3FA0",
  plum: "#5A2A4A",
  violet: "#7B5EA7",
  lilac: "#C8A2C8",
  lavender: "#B57EDC",
  blue: "#2F5DA8",
  navy: "#1F2A44",
  cobalt: "#0047AB",
  denim: "#4F6D8C",
  sky: "#8CBCE6",
  teal: "#2F7F7A",
  turquoise: "#40B5AD",
  green: "#3F6B4F",
  sage: "#8FA58B",
  mint: "#A8D5BA",
  olive: "#6B6B3F",
  mustard: "#C9A227",
  yellow: "#D4B429",
  gold: "#C9A227",
  silver: "#B8B8B8",
  grey: "#9B9B9B",
  gray: "#9B9B9B",
  charcoal: "#4A4A4A",
  slate: "#5F6B7A",
  stone: "#A8A29A",
  sand: "#CBB89D",
  khaki: "#A39A7A",
  zebra: "#1A1A1A",
  leopard: "#8B5A2B",
  print: "#D9D9D9",
};

export function getColourFamilyProducts(product) {
  const metaobject = product?.colourFamily?.reference;

  if (!metaobject?.fields) {
    return [];
  }

  const productsField = metaobject.fields.find(
    (field) => field.key === "products"
  );

  return unwrapNodes(productsField?.references?.edges) || [];
}

export function getColourFamilyProductUrl(product) {
  return product?.onlineStoreUrl || `/products/${product?.handle}`;
}

export function getColourFamilySwatchImage(product) {
  const reference = product?.swatchImage?.reference;

  if (!reference) {
    return null;
  }

  return reference.image?.url || reference.url || null;
}

export function getColourFamilySwatchColor(product) {
  const metafieldColor = product?.swatchColor?.value?.trim();

  if (metafieldColor) {
    if (/^#?[0-9A-Fa-f]{3,8}$/.test(metafieldColor)) {
      return metafieldColor.startsWith("#")
        ? metafieldColor
        : `#${metafieldColor}`;
    }

    const namedColor = SWATCH_COLOURS[metafieldColor.toLowerCase()];

    if (namedColor) {
      return namedColor;
    }
  }

  return getColourFromTitle(product?.title) || "#D9D9D9";
}

function getColourFromTitle(title) {
  if (!title) {
    return null;
  }

  const normalized = title.toLowerCase();
  const colourNames = Object.keys(SWATCH_COLOURS).sort(
    (left, right) => right.length - left.length
  );

  return (
    colourNames
      .map((colourName) => ({
        colourName,
        colour: SWATCH_COLOURS[colourName],
      }))
      .find(({ colourName }) => normalized.includes(colourName))?.colour || null
  );
}
